// Stylised network map of Africa — an architectural illustration, not live coverage data.
export const NetworkMap = ({ label }) => (
  <figure className="relative" data-testid="network-map">
    <svg viewBox="0 0 600 560" className="w-full h-auto" role="img" aria-label={label}>
      <defs>
        <linearGradient id="routeGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#FF6600" stopOpacity="0.15" />
          <stop offset="50%" stopColor="#FF9900" />
          <stop offset="100%" stopColor="#FF6600" stopOpacity="0.15" />
        </linearGradient>
        <radialGradient id="nodeGlow">
          <stop offset="0%" stopColor="#FF9900" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#FF6600" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Stylised Africa silhouette (abstract, not geographic precision) */}
      <path d="M300 40 C360 40 420 70 445 120 C470 165 480 200 460 250 C445 290 470 320 450 370 C430 425 390 470 340 500 C315 515 295 520 285 505 C270 480 250 450 225 420 C195 385 160 340 150 290 C140 240 150 190 175 150 C205 100 245 40 300 40 Z"
        fill="rgba(255,255,255,0.035)" stroke="rgba(255,255,255,0.14)" strokeWidth="1.2" />

      {/* concentric radar rings on DRC */}
      <g className="origin-[300px_290px] animate-[spin_30s_linear_infinite]">
        <circle cx="300" cy="290" r="70" fill="none" stroke="#FF6600" strokeOpacity="0.25" strokeWidth="1" strokeDasharray="3 6" />
        <circle cx="300" cy="290" r="110" fill="none" stroke="#FF6600" strokeOpacity="0.15" strokeWidth="1" strokeDasharray="2 8" />
      </g>
      <circle cx="300" cy="290" r="46" fill="none" stroke="#FF6600" strokeOpacity="0.4" strokeWidth="1" strokeDasharray="4 4" />

      {/* Regional routes from DRC hub */}
      {[
        "M300 290 Q 330 200 385 135",  // East Africa
        "M300 290 Q 250 380 305 480",  // Southern Africa
        "M300 290 Q 200 260 165 205",  // West Africa
        "M300 290 Q 350 330 445 340",  // Coast
      ].map((d, i) => (
        <path key={i} d={d} fill="none" stroke="url(#routeGrad)" strokeWidth="1.8" strokeLinecap="round"
          strokeDasharray="6 8" className="network-route" style={{ animationDelay: `${i * 0.6}s` }} />
      ))}

      {/* International arcs (leave the continent) */}
      <path d="M300 290 Q 200 120 60 60" fill="none" stroke="url(#routeGrad)" strokeWidth="1.6" strokeDasharray="5 9" className="network-route" />
      <path d="M300 290 Q 430 130 560 70" fill="none" stroke="url(#routeGrad)" strokeWidth="1.6" strokeDasharray="5 9" className="network-route" style={{ animationDelay: "0.9s" }} />
      <path d="M305 480 Q 420 520 560 490" fill="none" stroke="url(#routeGrad)" strokeWidth="1.4" strokeDasharray="5 9" className="network-route" style={{ animationDelay: "1.4s" }} />

      {/* Satellite link */}
      <path d="M300 290 Q 240 120 320 18" fill="none" stroke="#FFC000" strokeOpacity="0.55" strokeWidth="1.3" strokeDasharray="2 7" className="network-route" style={{ animationDelay: "0.4s" }} />
      <circle cx="320" cy="18" r="5" fill="#FFC000" />

      {/* Nodes */}
      {[
        [300, 290, 10, "#FF6600"], [385, 135, 6, "#FF9900"], [305, 480, 6, "#FF9900"],
        [165, 205, 6, "#FF9900"], [445, 340, 6, "#FF9900"], [60, 60, 5, "#A8ADB3"], [560, 70, 5, "#A8ADB3"], [560, 490, 5, "#A8ADB3"],
      ].map(([cx, cy, r, fill], i) => (
        <g key={i}>
          <circle cx={cx} cy={cy} r={r * 3} fill="url(#nodeGlow)" opacity="0.35" />
          <circle cx={cx} cy={cy} r={r} fill={fill} />
        </g>
      ))}

      <text x="300" y="320" textAnchor="middle" fill="#FFFFFF" fontSize="13" fontWeight="800" fontFamily="Lato, sans-serif">RDC</text>
      <text x="300" y="338" textAnchor="middle" fill="#A8ADB3" fontSize="9" fontFamily="monospace" letterSpacing="2">HUB — KINSHASA</text>
    </svg>
    <figcaption className="mt-4 text-center text-xs font-mono tracking-widest uppercase text-white/45">{label}</figcaption>
  </figure>
);
